"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Protected = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const useAuth_1 = require("../hooks/useAuth");
const LoginScreen_1 = require("../screens/LoginScreen");
const useAuthTokens_1 = require("../hooks/useAuthTokens");
const SelectLauScreen_1 = require("../screens/SelectLauScreen");
const Protected = ({ children }) => {
    const { isLogged } = (0, useAuthTokens_1.useAuthTokens)();
    const { activeLau } = (0, useAuth_1.useAuth)();
    if (isLogged) {
        if (!activeLau) {
            return (0, jsx_runtime_1.jsx)(SelectLauScreen_1.SelectLauScreen, { redirect: false });
        }
        else {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
        }
    }
    else {
        return (0, jsx_runtime_1.jsx)(LoginScreen_1.LoginScreen, {});
    }
};
exports.Protected = Protected;
